var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventory-data"},[_c('div',{attrs:{"className":"name"}},[_vm._v(" "+_vm._s(_vm.data.measuredQuantity)+" "+_vm._s(_vm.data.productInventory.product.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }